<div class="flex items-center justify-center bg-gray-100">
  <div class="w-full bg-white shadow-l p-4 md:p-8 space-y-6 rounded-lg">
    <div class="flex items-center gap-3 justify-between">
      <button class="text-gray-500 text-sm cursor-pointer flex items-center py-2 hover:underline" (click)="goBack()">
        <img ngSrc="/icons/back.svg" alt="" height="20" width="20">
        <div class="pr-2">
          Torna alla lista
        </div>
      </button>
      <button (click)="fetchProcedure()" class="self-start button primary">
        <img class="inline align-sub" ngSrc="/icons/refresh.svg" alt="" height="20" width="20">
        <span class="hidden md:inline">Aggiorna Procedura</span>
        <!-- <svg class="md:hidden" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/>
        </svg> -->
      </button>
    </div>
      @if(items$ | async; as item) {


        <div class="flex flex-col flex-1">

          <div class="flex flex-col flex-1">

            <div class="flex gap-3 items-center">
              <h3 class="text-gray-700 font-semibold">#{{ item.code }}</h3>
            </div>
            <h1 class="text-xl mt-5 mb-5">{{ item.label }}</h1>
            <div class="flex flex-wrap gap-x-3 text-gray-700 text-sm">
              <div>
                Registrato il {{ item.registration_date  | date: 'dd/MM/yyyy HH:mm:ss' }}
              </div>

            </div>
          </div>


          <div class="mt-6">
            <div class="py-4 [&>*:not(:last-child)]:border-b [&>*:not(:last-child)]:border-gray-300">
              @for (document of item.documents; track document.id) {
                <div class="p-4 transition-colors bg-gray-100 hover:bg-gray-100 odd:bg-white even:bg-gray-100">
                  <div class="flex items-center gap-5 w-full justify-between">
                    <span> {{ document.filename }}</span>
                    <div class="gap-5 flex">
                      <button class="button primary" (click)="previewDocument(document.id, document.mimetype)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M3 7V5a2 2 0 0 1 2-2h2"/>
                          <path d="M17 3h2a2 2 0 0 1 2 2v2"/>
                          <path d="M21 17v2a2 2 0 0 1-2 2h-2"/>
                          <path d="M7 21H5a2 2 0 0 1-2-2v-2"/>
                          <circle cx="12" cy="12" r="3"/>
                          <path d="m16 16-1.9-1.9"/>
                        </svg>
                      </button>
                      <button class="button primary" (click)="downloadDocument(document.id, document.mimetype)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 17V3"/>
                          <path d="m6 11 6 6 6-6"/>
                          <path d="M19 21H5"/>
                        </svg>
                      </button>

                    </div>
                  </div>
                </div>
              }
            </div>

            <div class="document-preview">
              <div class="dimmer" (click)="closePreview()"></div>
              <div class="preview-content">
                <iframe #iframe class="iframe"></iframe>
              </div>
            </div>

          </div>
        </div>

      }


  </div>
</div>
